import { Blocks as ArtistContainerBlocks, Page as ArtistContainerPage, TypeConfig as ArtistContainerTypeConfig } from './ArtistContainer.jsx';
import { Blocks as ArtistItemContainerBlocks } from './ItemContainer.jsx';
import { Tokens as ArtistMetaTokens } from './ArtistMeta.jsx';
import { Tokens as ItemMetaTokens } from './ItemMeta.jsx';
import Name from '../utility/Name.jsx';

const Blocks = {
    get: (group, data) => [
        {
            id: Name.Block.Artist.Container,
            component: ArtistContainerPage,
            config: {
                Block: ArtistContainerTypeConfig.panel.block(),
                Style: ArtistContainerTypeConfig.panel.style(),
                Visibility: ArtistContainerTypeConfig.panel.visibility(),
                defaults: [
                    { configName: 'Block', propertyName: 'design', propertyValue: ArtistContainerTypeConfig.defaultDesign(data) }
                ]
            },
            display: 'Artist Container',
            group,
            image: 'artists.png',
            type: 'container'
        }
    ]
};
const Content = {
    [Name.Block.Artist.Container]: ArtistContainerBlocks,
    [Name.Block.Inventory.Container]: ArtistItemContainerBlocks
};
const Tokens = {
    get: (id, data) => {
        switch (id) {
            case Name.Block.Artist.Meta:
                return ArtistMetaTokens();
            case Name.Block.Inventory.Meta:
                return ItemMetaTokens(data);
        }
    }
};

export {
    Blocks,
    Content,
    Tokens
}